import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import FullScreenTutorCard from "@/components/tutor/fullScreen-tutor-card";
import { Card } from "@/components/ui/card";
import { useTutor } from "@/services/entities/use-public-data";

export const Route = createFileRoute("/tutor/$tutorId")({
  component: TutorDetails,
});

function TutorDetails() {
  const { tutorId } = Route.useParams();
  const { tutor, error, isLoading } = useTutor(tutorId);

  if (error || (!tutor && !isLoading)) {
    return (
      <div className="min-h-screen bg-gray-100 p-4 md:p-8 flex items-center justify-center">
        <Card className="mx-auto max-w-4xl p-8">
          <p className="text-lg font-medium text-center text-red-600">
            Failed to find tutor&apos;s information. Please try again later.
          </p>
        </Card>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 p-4 md:p-8 flex items-center justify-center">
        <Card className="mx-auto max-w-4xl p-8">
          <div className="flex flex-col items-center gap-4">
            <Loader2 className="h-16 w-16 animate-spin text-primary" />
            <p className="text-lg font-medium">Loading tutor information...</p>
          </div>
        </Card>
      </div>
    );
  }

  if (!tutor) {
    return (
      <div className="min-h-screen bg-gray-100 p-4 md:p-8 flex items-center justify-center">
        <Card className="mx-auto max-w-4xl p-8">
          <p className="text-lg font-medium text-center">
            Tutor not found. Please check the URL and try again.
          </p>
        </Card>
      </div>
    );
  }

  return <FullScreenTutorCard tutor={tutor} />;
}
